import {NavLink, useNavigate} from "react-router-dom";
import {FilePdf, Question, SignOut, Table, UserCircle, UserCircleGear, Video} from "@phosphor-icons/react";
import {Avatar, Button, Dropdown} from "antd";
import React from "react";
import { MenuInfo } from 'rc-menu/lib/interface';
import {useCurrentUser} from "../../../../contexts/UserContext";
import Pdf from "../../../../assets/PDF/oneDRAW User Guide (Latest).pdf";
import getMsalInstance from "../../../../helpers/getMsalInstance";
import {useViewerStore} from "../../../../store/store";

type NavLinksProps = {
    username: string,
    setIsUserSettingsModalOpen: (open: boolean) => void
}

const NavLinks = (props: NavLinksProps) => {
    const {username, setIsUserSettingsModalOpen} = props;


    const {hasCapability} = useCurrentUser();
    const navigate = useNavigate();
    const instance = getMsalInstance();
    const isProfilePhotoAvailable = useViewerStore(state => state.isProfilePhotoAvailable);
    const userProfilePhoto = useViewerStore(state => state.userProfilePhoto);

    const handleSignOut = () => {
        sessionStorage.setItem("loginMessage", "Login with Microsoft");
        localStorage.clear();
        instance.logoutRedirect();
    };

    const menuItems = [
        {
            key: '1',
            label: (
                <a href='#' onClick={() => setIsUserSettingsModalOpen(true)}>
                    User Settings
                </a>
            ),
            icon: <UserCircleGear size={24} weight='fill'/>,
        },
        {
            key: '2',
            label: (
                <a onClick={handleSignOut}>Sign Out</a>
            ),
            icon: <SignOut size={24} weight='fill'/>
        }
    ];

    const onClick = (info: MenuInfo) => {
        const key = info.key
        if (key === 'userGuide') {
            //open pdf in new tab
            window.open(Pdf, '_blank');
        } else if (key === 'trainingVideos') {
            navigate('/training');
        }
    };
    const items = [
        {
            label: 'User Guide',
            key: 'userGuide',
            icon: <FilePdf size={24} weight='bold'/>
        },
        {
            label: 'Training Videos',
            key: 'trainingVideos',
            icon: <Video size={24} weight='bold'/>,

        },
    ];




    return (
        <div className={`header__dropdown`}>
            <ul className='header__nav'>
                {
                    hasCapability('Sites_Table') && <li>
                        <NavLink
                            to='/sites'
                            className='header__links'
                        >
                            <Table size={24} weight='bold'/>

                            Sites
                        </NavLink>
                    </li>
                }
                <li>

                    <Dropdown
                        menu={{
                            items,
                            onClick,
                        }}
                    >
                        <a
                            rel="noreferrer"
                            className={'header__links'}
                        >
                            <Question size={24} weight='bold'/>
                            Help
                        </a>
                    </Dropdown>


                </li>
            </ul>
            <div className='header__menu'>
                <Dropdown menu={{items: menuItems}}>
                    <Button
                        icon={isProfilePhotoAvailable ? <Avatar src={<img src={userProfilePhoto}/>} alt='profile' className='header__menu--item--icon'/> : <UserCircle size={24} weight='fill'/>}
                        size='middle'
                        type='text'
                        onClick={(e) => e.preventDefault()}
                        className='header__menu--item'
                    >{username !== '' ? username : 'User'}</Button>
                </Dropdown>
            </div>
        </div>
    )
}

export default NavLinks;